import React, { useState, useRef, useEffect } from "react";
import CountryDropdown from "./CountryDropdown"; // JS-based dropdown with flags
import "./Navbar.css";
import { useCountry } from '../contexts/CountryContext';

const defaultCountries = [ "SG", "MY", "ID", "PH", "VN", "TH"];

const Navbar = ({
  user,
  onSignOut,
  availableCountries,
  onNavigation
}) => {

const { selectedCountry, updateCountry, countries, setAvailableCountries,countryName } = useCountry();
    const [isDropdownOpen, setIsDropdownOpen] = useState(false);
  const dropdownRef = useRef(null);

  // Default user if not provided
  const userData = user || {
    name: "Admin User",
    avatar:
      "https://images.unsplash.com/photo-1535713875002-d1d0cf377fde?ixlib=rb-4.0.3&auto=format&fit=crop&w=100&q=80",
  };

  // Close user dropdown when clicking outside
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setIsDropdownOpen(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  const toggleDropdown = () => {
    setIsDropdownOpen(!isDropdownOpen);
  };

  const handleSignOut = () => {
    if (onSignOut) onSignOut();
    setIsDropdownOpen(false);
  };

  // Handle home button click
  const handleHomeClick = () => {
    onNavigation('home');
  };

  // Use passed countries or default
  const countriesToShow = availableCountries || defaultCountries;

  return (
    <header className="navbar">
      <div className="navbar-container">
        <div className="logo-container">
          <img
            src="https://assets.grab.com/wp-content/uploads/media/grab_logo.png"
            alt="Grab Logo"
            className="grab-logo-img"
          />
          {/* Home Button */}
          <button 
            className="home-button"
            onClick={handleHomeClick}
            aria-label="Go to homepage"
          >
            <svg 
              width="20" 
              height="20" 
              viewBox="0 0 24 24" 
              fill="none" 
              xmlns="http://www.w3.org/2000/svg"
            >
              <path 
                d="M3 9L12 2L21 9V20C21 20.5304 20.7893 21.0391 20.4142 21.4142C20.0391 21.7893 19.5304 22 19 22H5C4.46957 22 3.96086 21.7893 3.58579 21.4142C3.21071 21.0391 3 20.5304 3 20V9Z" 
                stroke="currentColor" 
                strokeWidth="2" 
                strokeLinecap="round" 
                strokeLinejoin="round"
              />
              <path 
                d="M9 22V12H15V22" 
                stroke="currentColor" 
                strokeWidth="2" 
                strokeLinecap="round" 
                strokeLinejoin="round"
              />
            </svg>
            <span>Home</span>
          </button>
        </div>

        <div className="navbar-right">
          {/* 🌍 Always show country dropdown */}
          <div className="country-dropdown-wrapper">
            <CountryDropdown
              selectedCountry={selectedCountry}
              onChange={updateCountry} // make sure onCountryChange exists
              availableCountries={countriesToShow}
            />
          </div>

          {/* 👤 User Info */}
          <div className="user-info" ref={dropdownRef}>
            <div className="user-dropdown-trigger" onClick={toggleDropdown}>
              <img
                src={userData.avatar}
                alt={userData.name}
                className="user-avatar"
              />
              <span className="user-name">{userData.name}</span>
              <i className={`dropdown-arrow ${isDropdownOpen ? "open" : ""}`}></i>
            </div>

            {isDropdownOpen && (
              <div className="user-dropdown">
                <div className="dropdown-item user-profile">
                  <i className="icon-user"></i>
                  <span>Profile</span>
                </div>
                <div className="dropdown-item user-settings">
                  <i className="icon-settings"></i>
                  <span>Settings</span>
                </div>
                <div className="dropdown-divider"></div>
                <div
                  className="dropdown-item user-signout"
                  onClick={handleSignOut}
                >
                  <i className="icon-signout"></i>
                  <span>Sign Out</span>
                </div>
              </div>
            )}
          </div>
        </div>

      </div>
    </header>
  );
};

export default Navbar;